import React, { Fragment, ReactElement, useState } from 'react'
import { Trans } from 'react-i18next'
import {
	Button,
	CircularProgress,
	Link,
	TextField,
	Typography,
} from '@material-ui/core'
import { Icons, PageContainer, Row } from '@copyrightagent/basic-components'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import useStyle from './style'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const translations = require('../Login/login.json')

const getErrorMessage = (code: string): string => {
	switch (code) {
		case 'auth/invalid-credential':
		case 'auth/wrong-password':
		case 'auth/user-not-found':
			return 'Incorrect email or password'
		case 'auth/invalid-email':
			return 'Invalid email address'
		case 'auth/too-many-requests':
			return 'Too many failed attempts. Please try again later'
		default:
			return 'Sign in failed. Please try again'
	}
}

const PasswordLoginPage = (): ReactElement => {
	const classes = useStyle()
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState('')

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault()
		setLoading(true)
		setError('')
		try {
			await signInWithEmailAndPassword(getAuth(), email, password)
			// onAuthStateChanged in useGetProfileEffect handles the redirect
		} catch (err: any) {
			setError(getErrorMessage(err.code))
			setLoading(false)
		}
	}

	return (
		<Fragment>
			<Icons.Logo className={classes.logo} />
			<PageContainer className={classes.page}>
				<form onSubmit={handleSubmit} className={classes.form}>
					<Typography variant="h4" className={classes.title}>
						Welcome back
					</Typography>
					<TextField
						type="email"
						variant="outlined"
						placeholder="Your email address"
						fullWidth
						autoComplete="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						disabled={loading}
					/>
					<TextField
						type="password"
						variant="outlined"
						placeholder="Your password"
						fullWidth
						autoComplete="current-password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						disabled={loading}
					/>
					{error && (
						<Typography className={classes.error}>{error}</Typography>
					)}
					<Button
						type="submit"
						variant="contained"
						color="primary"
						fullWidth
						disabled={loading}
						className={classes.button}
					>
						{loading ? (
							<CircularProgress size={20} color="inherit" />
						) : (
							'Sign in'
						)}
					</Button>
				</form>
				<Row className={classes.bottom}>
					<Typography className={classes.terms}>
						<Trans
							components={[
								<Link
									key="terms"
									className={classes.termsLink}
									href="https://copyrightagent.com/legal/terms/"
									target="_blank"
								/>,
								<Link
									key="privacy"
									className={classes.termsLink}
									href="https://copyrightagent.com/privacy/"
									target="_blank"
								/>,
							]}
						>
							{translations.terms}
						</Trans>
					</Typography>
				</Row>
			</PageContainer>
		</Fragment>
	)
}

export default PasswordLoginPage
